<template>
  <div class="skipNav" id="skipNav"><a href="#contents">skip to contents</a></div>
</template>

<script>
export default {
  name: 'NavigationSkip',
  components: {
  },
  data() {
    return {
    }
  },
}
</script>

<style lang="scss">
.skipNav {
  height: 1px;
  width: 1px;
  margin: 0 -1px -1px 0;
  a {
    display: block;
    height: 1px;
    width: 1px;
    padding: 0;
    overflow: hidden;
    font-size: 0;
    line-height: 0;
    &:hover,
    &:active,
    &:focus {
      position: absolute;
      top: 0;
      left: 0;
      height: auto;
      width: auto;
      margin: 0;
      padding: 5px 20px;
      font-size: 12px;
      line-height: 1;
      background-color: #ffffff;
      color: #000000;
      z-index: 100000;
    }
  }
}
</style>

